/**
 * 卡片页
 */
import React from 'react';
import PropTypes from 'prop-types';

class Main extends React.Component {

    render() {
        return (
            <div>工作台-卡片页</div>
        );
    }
}

Main.propTypes = {
    history: PropTypes.object, // 路由
};

export default Main;